import { dialog } from "../../nq-component";
import BaseFormPresenter from "../../base/BaseFormPresenter";

class JobDescriptionPresenter extends BaseFormPresenter {
  constructor(
    view,
    findObjectUseCase,
    upsertUseCase,
    getObjectUseCase,
    signOutUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase
  ) {
    super(
      view,
      findObjectUseCase,
      upsertUseCase,
      getObjectUseCase,
      signOutUseCase,
      countObjectUseCase,
      deleteObjectUseCase
    );
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
    this.signOutUseCase = signOutUseCase;
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  getObjectJob = async () => {
    const collection = this.view.getCollectionName();
    const objectId = this.view.getObjectId();
    const option = {};

    try {
      const result = await this.getObjectUseCase.execute(
        collection,
        objectId,
        option
      );
      return result;
    } catch (error) {
      console.error("Error fetching job object:", error);
      return null;
    }
  };

  onClickApplyNow = async () => {
    try {
      const user = this.view.getCurrentUser();
      const selected = await this.getObjectJob();

      if (!selected) {
        console.error("No job object found.");
        return;
      }

      const arrayObject = [];
      arrayObject.push(selected);
      const objects = arrayObject;

      if (user) {
        localStorage.setItem("selectedJobs", JSON.stringify(objects));
        this.view.navigateTo(`/job-list/application-form/`);
      } else {
        localStorage.setItem("selectedJobs", JSON.stringify(objects));
        this.view.navigateTo(`/signin`);
      }
    } catch (error) {
      console.error("Error in onClickApplyNow:", error);
    }
  };

  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(() => this.signOutUseCase.execute())
      .then(() => {
        localStorage.removeItem("selectedJobs");
        localStorage.removeItem("user");
        this.view.navigateTo("/signin");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }
}

export default JobDescriptionPresenter;
